import { api } from '../../config/base-api';
import type {
  ContinuePaymentV3Params,
  ContinuePaymentV3Response,
} from './types';

// A continuidade roda no meio da cerimônia, com o comprador parado na tela.
// Timeout curto o bastante para não deixá-lo esperando indefinidamente e longo
// o bastante para o round-trip até o provider.
const CONTINUE_TIMEOUT_IN_MS = 60000;

/**
 * FIN-7470 (C3DS-07): gatilho que o front dispara depois de executar uma etapa
 * da autenticação. Corpo vazio de propósito — o BFF já tem tudo o que precisa
 * pelo `chargeId`; mandar dados daqui seria confiar no cliente.
 */
export async function continuePaymentV3({
  chargeId,
  business,
}: ContinuePaymentV3Params): Promise<ContinuePaymentV3Response> {
  const res = await api.post<ContinuePaymentV3Response>(
    `/api/v3/payment/${encodeURIComponent(chargeId)}/continue`,
    {},
    {
      params: { business },
      timeout: CONTINUE_TIMEOUT_IN_MS,
    }
  );

  return res.data;
}
